import servise from '@/router/axios'

export const updateSubjectCollect = (body) => {
    return servise({
        url: '/subjectCollect/get/dsp/subject',
        method: 'put',
        data: body
    })
}
export const getInvoicing = (params) => {
    return servise({
        url: '/subjectInfo/get/invoicing/subject',
        data: params
    })
}
export const updateFormerName = (data) => {
    return servise({
        url: '/subjectCollect/get/dsp/subject/former/name',
        method: 'put',
        data
    })
}